import { Component } from '@angular/core';

@Component({
  selector: 'app-whatsapp-icon',
  standalone: true,
  imports: [],
  templateUrl: './whatsapp-icon.component.html',
  styleUrl: './whatsapp-icon.component.scss'
})
export class WhatsappIconComponent {

}
